<template>
  <div class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
    <div class="modal-dialog modal-md modal-dialog-centered" ref="modalRef">
      <div class="modal-content">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between px-1 my-1 align-item-center">
              <h1 class="mb-0">Job Stage</h1>
              <button
                  @click="onClickClose"
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
              ></button>
            </div>
          </div>
        </div>

        <hr class="mt-0 mb-0">

        <div class="pb-2">
          <div class="row mx-2">
            <div class="col-12">
              <label class="form-label">Select Stage</label>
              <v-select
                  placeholder="Select Stage"
                  :options="dealStageList"
                  v-model="formData.note_master_id"
                  :reduce="option => option.id"
                  label="name"
              />
            </div>

            <div class="col-12">
              <div class="mb-1">
                <label class="form-label" for="mobileNo">Date Time </label>
                <input
                    class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                    tabindex="1"
                    type="datetime-local"
                    placeholder=""
                    v-model="formData.start_time"
                >
              </div>
            </div>

            <div class="col-12">
              <div class="mb-1">
                <label class="form-label" for="mobileNo">Note </label>
                <TipTapEditor
                    v-model:content="formData.note"
                />
              </div>
            </div>

            <div class="col-6 text-center mb-2 mt-2">
              <button :disabled="loading" @click="submit" type="button" class="btn btn-primary full-width me-1 waves-effect waves-float waves-light">
                <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loader v-if="loader"/>

  </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import {inject, onMounted, ref, watch} from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import useDate from '@/services/utils/day'
import handleHospital from '@/services/modules/hospital';
import { getCurrentDateTime } from '@/services/utils/global.js';
import TipTapEditor from '@/components/atom/TipTapEditor';
import handleProjects from "@/services/modules/procurement/project";

const formData = ref({
  start_time:getCurrentDateTime(),
  note_master_id:null,
  note:'',
})

const props = defineProps({
  projectId: {
    default: null
  }
})

const emit = defineEmits(['close', 'getActivityLogData']);
const $store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const loading = ref(false);
const isEdit = ref(false);
const loader = ref(false);
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const { formatDateTime, formatToDate } = useDate()
const dealStageList = ref([]);

const { fetchNoteMasterList } = handleHospital();
const { createJobStage } = handleProjects();

const submit = async() => {
  const query = getQuery();
  loading.value = true;
  await storeData(query)
}

const storeData = async (query) => {
  let beneficiaryStageData = {};
  beneficiaryStageData.start_time = formData.value.start_time;
  beneficiaryStageData.date = formData.value.start_time ? formatToDate(formData.value.start_time)
      : new Date().toISOString().split('T')[0];
  beneficiaryStageData.note_master_id = formData.value.note_master_id;
  beneficiaryStageData.note = formData.value.note;
  beneficiaryStageData.type = 'job_stage';
  beneficiaryStageData.project_id = props.projectId;

  await createJobStage(beneficiaryStageData, query).then((res) => {
    loading.value = false
    if (!res.status) return showError(res.message)
    emit('getActivityLogData')
    onClickClose();
    showSuccess(res.message)
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getDealList = async () => {
  const query = `?company_id=${$route.params.companyId}&note_type=job_stage`;
  try {
    const res = await fetchNoteMasterList(query);
    if (!res.status) {
      return showError(res.message);
    }
    dealStageList.value = res.data.data;
  } catch (err) {
    console.error(err);
  }
};

onMounted( async () => {
  await getDealList();
})

const onClickClose = () => {
  emit('close')
}

function getQuery() {
  return `?company_id=${$route.params.companyId}`;
}

</script>
